import {
  colorStyle,
  darkPalette,
  primaryBorder,
  windowBackground,
} from "@kaggle/core";
import styled from "styled-components";

/** Spacer button that sits between cells. */
export const SpacerButton = styled.button`
  ${windowBackground("#fff")};
  ${colorStyle({
    light: "rgba(0, 0, 0, 0.5)",
    dark: darkPalette.text[50],
  })};
  ${primaryBorder()};
  align-items: center;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  font-family: ${p => p.theme.km.typography.fontFamily.body};
  font-size: 1em;
  font-weight: 500;
  height: 2em;
  justify-content: center;
  min-width: 110px;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
  width: fit-content;

  &:hover {
    ${colorStyle({
      light: "#008abc",
      dark: darkPalette.accent,
    })};
  }
`;
